import { render, staticRenderFns } from "./StickyMenu.vue?vue&type=template&id=3b598091&"
import script from "./StickyMenu.vue?vue&type=script&lang=js&"
export * from "./StickyMenu.vue?vue&type=script&lang=js&"
import style0 from "./StickyMenu.vue?vue&type=style&index=0&id=3b598091&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports